/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const BathtubOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M6.75 18.375v2.25m10.5-2.25v2.25m-12-10.5v-4.87a1.88 1.88 0 0 1 1.875-1.88A1.88 1.88 0 0 1 9 5.255m9.75 4.87h3a.751.751 0 0 1 .75.75v3c0 1.19-.474 2.34-1.318 3.18A4.477 4.477 0 0 1 18 18.375H6a4.477 4.477 0 0 1-3.182-1.32 4.494 4.494 0 0 1-1.318-3.18v-3a.751.751 0 0 1 .75-.75h10.5m0-.75h6v4.5h-6v-4.5z"
})));
// Fill
const BathtubFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M21.75 9.375h-1.875a.751.751 0 0 0-.75-.75h-6.75a.751.751 0 0 0-.75.75H6v-4.12a1.127 1.127 0 0 1 1.125-1.13 1.127 1.127 0 0 1 1.125 1.13c0 .19.079.38.22.53.14.14.331.21.53.21s.39-.07.53-.21c.141-.15.22-.34.22-.53a2.625 2.625 0 1 0-5.25 0v4.12H2.25c-.398 0-.779.16-1.061.44-.281.28-.439.66-.439 1.06v3c0 1.39.553 2.73 1.538 3.71.984.99 2.32 1.54 3.712 1.54v1.5a.751.751 0 0 0 1.5 0v-1.5h9v1.5a.751.751 0 0 0 1.5 0v-1.5c1.392 0 2.728-.55 3.712-1.54a5.24 5.24 0 0 0 1.538-3.71v-3c0-.4-.158-.78-.439-1.06a1.508 1.508 0 0 0-1.061-.44zm-3.375.75v3.37h-5.25v-3.37h5.25z"
})));
// DuoTone
const BathtubDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M21.75 10.125h-3v3.75h-6v-3.75H2.25a.751.751 0 0 0-.75.75v3c0 1.19.474 2.34 1.318 3.18A4.477 4.477 0 0 0 6 18.375h12c1.193 0 2.338-.47 3.182-1.32a4.494 4.494 0 0 0 1.318-3.18v-3a.751.751 0 0 0-.75-.75z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M6.75 18.375v2.25m10.5-2.25v2.25m-12-10.5v-4.87a1.88 1.88 0 0 1 1.875-1.88A1.88 1.88 0 0 1 9 5.255m9.75 4.87h3a.751.751 0 0 1 .75.75v3c0 1.19-.474 2.34-1.318 3.18A4.477 4.477 0 0 1 18 18.375H6a4.477 4.477 0 0 1-3.182-1.32 4.494 4.494 0 0 1-1.318-3.18v-3a.751.751 0 0 1 .75-.75h10.5m0-.75h6v4.5h-6v-4.5z"
})));
/**
  Icon BathtubIcon in commerce group
*/
export const BathtubIcon = createIcon('BathtubIcon', 'bathtub', 'commerce', BathtubOutline, BathtubFill, BathtubDuotone, "0 0 24 24");